import PropTypes from 'prop-types';
import React from 'react';
import Autosuggest from 'react-bootstrap-autosuggest';
import { FormControl, FormGroup, HelpBlock } from 'react-bootstrap';
import RequirableControlLabel from '../RequirableControlLabel/RequirableControlLabel';
import './TimeFormGroup.css';

const isError = (error, touched) => (error && touched ? 'error' : null);

const getTimes = () => {
  const times = [];
  ['AM', 'PM'].forEach((suffix) => {
    ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'].forEach((hour) => {
      times.push({ value: `${hour}:00${suffix}`, sortKey: `${suffix}${hour}:00` });
      times.push({ value: `${hour}:15${suffix}`, sortKey: `${suffix}${hour}:15` });
      times.push({ value: `${hour}:30${suffix}`, sortKey: `${suffix}${hour}:30` });
      times.push({ value: `${hour}:45${suffix}`, sortKey: `${suffix}${hour}:45` });
    });
  });
  return times;
};

// eslint-disable-next-line object-curly-newline
const TTFormGroup = ({ label, meta, input, required, ...props }) => {
  const handleTheChange = (a) => {
    input.onChange(a);
    props.onFieldChange();
  };

  return (
    <FormGroup validationState={isError(meta.error, meta.touched)}>
      {label && <RequirableControlLabel required={required}>{label}</RequirableControlLabel>}

      <Autosuggest
        {...input}
        {...props}
        datalist={getTimes()}
        onChange={handleTheChange}
        placeholder="00:00AM"
        class="form-control"
      />
      <FormControl.Feedback />
      {(meta.touched && meta.error) && <HelpBlock>{meta.error}</HelpBlock>}
    </FormGroup>
  );
};

TTFormGroup.defaultProps = {
  label: '',
  meta: {},
  input: {},
  required: false,
  onFieldChange: () => {},
};

TTFormGroup.propTypes = {
  label: PropTypes.string,
  required: PropTypes.bool,
  meta: PropTypes.shape({}),
  input: PropTypes.shape({}),
  onFieldChange: PropTypes.fn,
};

export default TTFormGroup;



// WEBPACK FOOTER //
// ./src/components/Forms/TimeFormGroup/TimeFormGroup.jsx